import { render, staticRenderFns } from "./ProductCategoryProvider.vue?vue&type=template&id=11b064d0&"
import script from "./ProductCategoryProvider.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports